import React, { forwardRef, Ref } from 'react';

import { StyledRadio } from './Radio.styles';

import { RadioProps } from './Radio.types';

/**
 * Primary UI component for user interaction
 */
const Radio = forwardRef(
  (
    {
      onChange,
      onClick,
      inputProps,
      labelProps,
      isChecked,
      isDisabled = false,
      label,
      name,
      componentClassname = 'radio',
      customClassnames = '',
      customStyle = '',
    }: RadioProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    return (
      <StyledRadio
        className={`${componentClassname} ${customClassnames}`}
        onClick={!isDisabled && onClick}
        isChecked={isChecked}
        isDisabled={isDisabled}
        customStyle={customStyle}
      >
        <div className={`${componentClassname}__input-wrapper`}>
          <input
            type="radio"
            className={`${componentClassname}__input`}
            name={name}
            readOnly={!onChange}
            checked={isChecked}
            disabled={isDisabled}
            onChange={onChange}
            ref={ref}
            {...inputProps}
          />
        </div>
        <label
          htmlFor={name}
          className={`${componentClassname}__label`}
          {...labelProps}
        >
          {label}
        </label>
      </StyledRadio>
    );
  },
);
Radio.displayName = 'Radio';

export default Radio;
